import CustomField from "../../../state/custom-fields/CustomField"
import { FormInputParametersDto, InputFormOptions } from "../../../state/integration/form-options/types"
import { ExternalForm, ExternalFormField } from "../../../state/integration/wix"

export const mapInputParametersToOptions = (inputParameters: FormInputParametersDto[]): InputFormOptions[] => {
    return inputParameters.map(({ key, ...rest }) => ({
        value: key,
        ...rest
    }))
}

export const matchExternalFormToQMFields = (
    formInputParameters: FormInputParametersDto[], 
    externalFormFields: ExternalFormField[]
): FormInputParametersDto[] => {
    const mapping: FormInputParametersDto[] = externalFormFields?.map(field => {
        const newMapping: FormInputParametersDto = {
            key: field.displayName,
            label: "",
        }
        const matchedField = formInputParameters?.find(item => item.key === field.displayName)
        if(matchedField != undefined && matchedField.key != "") {
            newMapping.label = matchedField.label
        }
        return newMapping
    })
    return mapping
}

export function validateFormFields(mapping: FormInputParametersDto[]): boolean {
    return mapping.some(field => field.isRequired && field.key.trim().length > 0)
}

export const mapCustomFieldsToOptions = (customFields: CustomField[]): FormInputParametersDto[] => {
    return customFields.map((cf) => {
        return {
            key: "",
            label: cf.dto.attributes.name,
            type: cf.dto.attributes.fieldType,
            customFieldId: cf.getId(),
            isRequired: false,
            optionValues: cf.dto.attributes.availableFrom,
        }
    })
}

export const wasExternalFormChanged = (prevSelectedForm: ExternalForm | undefined, selectedExtForm: ExternalForm): boolean => {
    return prevSelectedForm !== undefined 
    && prevSelectedForm.displayName !== "" 
    && selectedExtForm.displayName !== prevSelectedForm.displayName
}


// WEBPACK FOOTER //
// ./src/utils/integration/wix/utils.ts